// Public specifications only. Supplier costs and original workbooks are excluded.
export const HEATER_CATALOG_DATA = [
  {
    "model": "JHL016",
    "gas": false,
    "form": "standing",
    "type": "Freestanding halogen heater",
    "typeZh": "落地卤素取暖器",
    "power": "3000W (Max)",
    "control": "Remote and Touch button",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Freestanding halogen heater",
      "3000W (Max)",
      "Remote and Touch button",
      "Telescopic pole (1.6m -2.05m)",
      "Tip-over cut-off"
    ],
    "description": "JHL016 is a freestanding halogen heater with 3000W (Max) output and remote and touch button.",
    "longDescription": "JHL016 is a freestanding halogen heater with 3000W (Max) output and remote and touch button. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL016 为落地卤素取暖器，输出功率 3000W (Max)。",
    "longDescriptionZh": "JHL016 为落地卤素取暖器，输出功率 3000W (Max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL016"
      },
      {
        "label": "Power",
        "value": "3000W (Max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Remote and Touch button"
      },
      {
        "label": "Heat settings",
        "value": "3 (1200W-1800W-3000W)"
      },
      {
        "label": "Height",
        "value": "Telescopic pole (1.6m -2.05m)"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off"
      },
      {
        "label": "Material",
        "value": "Stainless Steel, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "16/18 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "77 × 77 × 42 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHL001-MI",
    "gas": false,
    "form": "table",
    "type": "Tabletop halogen heater",
    "typeZh": "桌面卤素取暖器",
    "power": "750-1500W",
    "control": "Rocker Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Tabletop halogen heater",
      "750-1500W",
      "Rocker Switch",
      "Tip-over cut-off"
    ],
    "description": "JHL001-MI is a tabletop halogen heater with 750-1500W output and rocker switch.",
    "longDescription": "JHL001-MI is a tabletop halogen heater with 750-1500W output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL001-MI 为桌面卤素取暖器，输出功率 750-1500W。",
    "longDescriptionZh": "JHL001-MI 为桌面卤素取暖器，输出功率 750-1500W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL001-MI"
      },
      {
        "label": "Power",
        "value": "750-1500W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off ， Safety Mesh"
      },
      {
        "label": "Material",
        "value": "Iron, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "42.5 x 42.5 x 78 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "5.1 / 6.5 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "47 × 47 × 35 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHD001-BZ",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "2100W (Max)",
    "control": "Remote and Touch button",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "2100W (Max)",
      "Remote and Touch button"
    ],
    "description": "JHD001-BZ is a hanging halogen heater with 2100W (Max) output and remote and touch button.",
    "longDescription": "JHD001-BZ is a hanging halogen heater with 2100W (Max) output and remote and touch button. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD001-BZ 为吊顶卤素取暖器，输出功率 2100W (Max)。",
    "longDescriptionZh": "JHD001-BZ 为吊顶卤素取暖器，输出功率 2100W (Max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD001-BZ"
      },
      {
        "label": "Power",
        "value": "2100W (Max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Remote and Touch button"
      },
      {
        "label": "Heat settings",
        "value": "3 (900W-1200W-2100W)"
      },
      {
        "label": "Material",
        "value": "Iron, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "70 x 70 x 32 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "4.4 / 6.5 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "76 × 76 × 34.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHL001-MIZ",
    "gas": false,
    "form": "table",
    "type": "Tabletop halogen heater",
    "typeZh": "桌面卤素取暖器",
    "power": "750-1500W",
    "control": "Rocker Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Tabletop halogen heater",
      "750-1500W",
      "Rocker Switch",
      "Tip-over cut-off"
    ],
    "description": "JHL001-MIZ is a tabletop halogen heater with 750-1500W output and rocker switch.",
    "longDescription": "JHL001-MIZ is a tabletop halogen heater with 750-1500W output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL001-MIZ 为桌面卤素取暖器，输出功率 750-1500W。",
    "longDescriptionZh": "JHL001-MIZ 为桌面卤素取暖器，输出功率 750-1500W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL001-MIZ"
      },
      {
        "label": "Power",
        "value": "750-1500W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off ， Safety Mesh"
      },
      {
        "label": "Material",
        "value": "Aluminum,iron"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "50 x 50 x 81 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "7.7 / 8.3 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "52 × 52 × 34.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHL019-B",
    "gas": false,
    "form": "standing",
    "type": "Carbon radiant heater",
    "typeZh": "碳纤维辐射取暖器",
    "power": "2000W(max)",
    "control": "Rocker switch, remote and touch control",
    "heating": "Carbon heating tube",
    "features": [
      "Carbon radiant heater",
      "2000W(max)",
      "Rocker switch, remote and touch control",
      "Timer up to 8 hours"
    ],
    "description": "JHL019-B is a carbon radiant heater with 2000W(max) output and rocker switch, remote and touch control.",
    "longDescription": "JHL019-B is a carbon radiant heater with 2000W(max) output and rocker switch, remote and touch control. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL019-B 为碳纤维辐射取暖器，输出功率 2000W(max)。",
    "longDescriptionZh": "JHL019-B 为碳纤维辐射取暖器，输出功率 2000W(max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL019-B"
      },
      {
        "label": "Power",
        "value": "2000W(max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "Carbon heating tube"
      },
      {
        "label": "Control",
        "value": "Rocker switch, remote and touch control"
      },
      {
        "label": "Heat settings",
        "value": "0-800-1400-2000W"
      },
      {
        "label": "Timer",
        "value": "Yes, up to 8hs"
      },
      {
        "label": "Material",
        "value": "iron, aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "5.5/6 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "119 × 18 × 18 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHD001-BLED",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "3000W (max)",
    "control": "Remote and Touch button",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "3000W (max)",
      "Remote and Touch button",
      "LED lighting"
    ],
    "description": "JHD001-BLED is a hanging halogen heater with 3000W (max) output and remote and touch button.",
    "longDescription": "JHD001-BLED is a hanging halogen heater with 3000W (max) output and remote and touch button. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space. Confirm individual heat-setting wattages when ordering.",
    "descriptionZh": "JHD001-BLED 为吊顶卤素取暖器，输出功率 3000W (max)。",
    "longDescriptionZh": "JHD001-BLED 为吊顶卤素取暖器，输出功率 3000W (max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。 各档功率请在订购时确认。",
    "notes": [
      "Confirm individual heat-setting wattages when ordering."
    ],
    "notesZh": [
      "各档功率请在订购时确认。"
    ],
    "specs": [
      {
        "label": "Model",
        "value": "JHD001-BLED"
      },
      {
        "label": "Power",
        "value": "3000W (max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Remote and Touch button"
      },
      {
        "label": "LED",
        "value": "Support"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "58.5 x 58.5 x 32 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "3.8 / 5.42 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "61 × 61 × 34.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD002",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1000W",
    "control": "Pull-cord Switch",
    "heating": "1 Halogen Heating tube",
    "features": [
      "Hanging halogen heater",
      "1000W",
      "Pull-cord Switch"
    ],
    "description": "JHD002 is a hanging halogen heater with 1000W output and pull-cord switch.",
    "longDescription": "JHD002 is a hanging halogen heater with 1000W output and pull-cord switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD002 为吊顶卤素取暖器，输出功率 1000W。",
    "longDescriptionZh": "JHD002 为吊顶卤素取暖器，输出功率 1000W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD002"
      },
      {
        "label": "Power",
        "value": "1000W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "1 Halogen Heating tube"
      },
      {
        "label": "Control",
        "value": "Pull-cord Switch"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "42.5 x 42.5 x 24 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "1.47 / 2.54 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "45 × 45 × 29 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD005",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1500W (max)",
    "control": "Pull-cord Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "1500W (max)",
      "Pull-cord Switch"
    ],
    "description": "JHD005 is a hanging halogen heater with 1500W (max) output and pull-cord switch.",
    "longDescription": "JHD005 is a hanging halogen heater with 1500W (max) output and pull-cord switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD005 为吊顶卤素取暖器，输出功率 1500W (max)。",
    "longDescriptionZh": "JHD005 为吊顶卤素取暖器，输出功率 1500W (max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD005"
      },
      {
        "label": "Power",
        "value": "1500W (max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Pull-cord Switch"
      },
      {
        "label": "Heat settings",
        "value": "3 （600W-900W-1500W)"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "42.5 x 42.5 x 24 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "1.5 / 2.7 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "45 × 45 × 29 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD006",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1500W (max)",
    "control": "Pull-cord Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "1500W (max)",
      "Pull-cord Switch"
    ],
    "description": "JHD006 is a hanging halogen heater with 1500W (max) output and pull-cord switch.",
    "longDescription": "JHD006 is a hanging halogen heater with 1500W (max) output and pull-cord switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD006 为吊顶卤素取暖器，输出功率 1500W (max)。",
    "longDescriptionZh": "JHD006 为吊顶卤素取暖器，输出功率 1500W (max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD006"
      },
      {
        "label": "Power",
        "value": "1500W (max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Pull-cord Switch"
      },
      {
        "label": "Heat settings",
        "value": "3 （600W-900W-1500W)"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "42.5 x 42.5 x 24 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "1.55 / 2.7 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "45 × 45 × 29 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD008",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1500W (max)",
    "control": "Pull-cord Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "1500W (max)",
      "Pull-cord Switch"
    ],
    "description": "JHD008 is a hanging halogen heater with 1500W (max) output and pull-cord switch.",
    "longDescription": "JHD008 is a hanging halogen heater with 1500W (max) output and pull-cord switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD008 为吊顶卤素取暖器，输出功率 1500W (max)。",
    "longDescriptionZh": "JHD008 为吊顶卤素取暖器，输出功率 1500W (max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD008"
      },
      {
        "label": "Power",
        "value": "1500W (max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Pull-cord Switch"
      },
      {
        "label": "Heat settings",
        "value": "3 （600W-900W-1500W)"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "42.5 x 42.5 x 31 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "2.5 / 3.9 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "47 × 47 × 34 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD007",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1200W",
    "control": "Pull-cord Switch",
    "heating": "1 Halogen Heating tube",
    "features": [
      "Hanging halogen heater",
      "1200W",
      "Pull-cord Switch"
    ],
    "description": "JHD007 is a hanging halogen heater with 1200W output and pull-cord switch.",
    "longDescription": "JHD007 is a hanging halogen heater with 1200W output and pull-cord switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD007 为吊顶卤素取暖器，输出功率 1200W。",
    "longDescriptionZh": "JHD007 为吊顶卤素取暖器，输出功率 1200W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD007"
      },
      {
        "label": "Power",
        "value": "1200W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "1 Halogen Heating tube"
      },
      {
        "label": "Control",
        "value": "Pull-cord Switch"
      },
      {
        "label": "Heat settings",
        "value": "1"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "2.15 / 3.2 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "44 × 44 × 24.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHD007P",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "1500W",
    "control": "Plug-in operation (no switch)",
    "heating": "1 Halogen Heating tube",
    "features": [
      "Hanging halogen heater",
      "1500W",
      "Plug-in operation (no switch)"
    ],
    "description": "JHD007P is a hanging halogen heater with 1500W output and plug-in operation (no switch).",
    "longDescription": "JHD007P is a hanging halogen heater with 1500W output and plug-in operation (no switch). Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD007P 为吊顶卤素取暖器，输出功率 1500W。",
    "longDescriptionZh": "JHD007P 为吊顶卤素取暖器，输出功率 1500W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD007P"
      },
      {
        "label": "Power",
        "value": "1500W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "1 Halogen Heating tube"
      },
      {
        "label": "Control",
        "value": "Plug-in operation (no switch)"
      },
      {
        "label": "Material",
        "value": "Aluminum, iron"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "1.8 / 2.7 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "44 × 44 × 21 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHD010",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "700W",
    "control": "Rocker Switch",
    "heating": "1 Halogen Heating tube",
    "features": [
      "Hanging halogen heater",
      "700W",
      "Rocker Switch"
    ],
    "description": "JHD010 is a hanging halogen heater with 700W output and rocker switch.",
    "longDescription": "JHD010 is a hanging halogen heater with 700W output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHD010 为吊顶卤素取暖器，输出功率 700W。",
    "longDescriptionZh": "JHD010 为吊顶卤素取暖器，输出功率 700W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHD010"
      },
      {
        "label": "Power",
        "value": "700W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "1 Halogen Heating tube"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Material",
        "value": "Aluminum,iron"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "1.2 / 1.5 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "28 × 28 × 25 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG019-BM",
    "gas": false,
    "form": "configurable",
    "type": "Carbon patio heater",
    "typeZh": "碳纤维庭院取暖器",
    "power": "2000W(max)",
    "control": "Rocker switch, remote and touch control",
    "heating": "Carbon heating tube",
    "features": [
      "Carbon patio heater",
      "2000W(max)",
      "Rocker switch, remote and touch control",
      "Timer up to 8 hours"
    ],
    "description": "JHG019-BM is a carbon patio heater with 2000W(max) output and rocker switch, remote and touch control.",
    "longDescription": "JHG019-BM is a carbon patio heater with 2000W(max) output and rocker switch, remote and touch control. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space. Tripod shown. Confirm stand and wall-mount hardware with your order.",
    "descriptionZh": "JHG019-BM 为碳纤维庭院取暖器，输出功率 2000W(max)。",
    "longDescriptionZh": "JHG019-BM 为碳纤维庭院取暖器，输出功率 2000W(max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。 图片展示三脚架配置，支架和壁挂附件请在订购时确认。",
    "notes": [
      "Tripod shown. Confirm stand and wall-mount hardware with your order."
    ],
    "notesZh": [
      "图片展示三脚架配置，支架和壁挂附件请在订购时确认。"
    ],
    "specs": [
      {
        "label": "Model",
        "value": "JHG019-BM"
      },
      {
        "label": "Power",
        "value": "2000W(max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "Carbon heating tube"
      },
      {
        "label": "Control",
        "value": "Rocker switch, remote and touch control"
      },
      {
        "label": "Heat settings",
        "value": "3 （650W-1300W-2000W)"
      },
      {
        "label": "Timer",
        "value": "Yes, up to 8hs"
      },
      {
        "label": "Material",
        "value": "iron, aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Net / gross weight",
        "value": "6 / 7.2 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "95 × 34 × 19 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHG-D1",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "max 13KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "max 13KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "Anti-tilt shut-off"
    ],
    "description": "JHG-D1 is a gas patio heater with max 13KW output and piezoelectric ignition.",
    "longDescription": "JHG-D1 is a gas patio heater with max 13KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-D1 为户外燃气取暖器，输出功率 max 13KW。",
    "longDescriptionZh": "JHG-D1 为户外燃气取暖器，输出功率 max 13KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-D1"
      },
      {
        "label": "Power",
        "value": "max 13KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1280mm"
      },
      {
        "label": "Safety",
        "value": "Anti-tilt switch and automatic shut-off"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "15 /17 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "45 × 45 × 76 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-D2",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "max 13KW",
    "control": "Pulse ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "max 13KW",
      "Pulse ignition",
      "Outdoor use only",
      "Anti-tilt shut-off"
    ],
    "description": "JHG-D2 is a gas patio heater with max 13KW output and pulse ignition.",
    "longDescription": "JHG-D2 is a gas patio heater with max 13KW output and pulse ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-D2 为户外燃气取暖器，输出功率 max 13KW。",
    "longDescriptionZh": "JHG-D2 为户外燃气取暖器，输出功率 max 13KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-D2"
      },
      {
        "label": "Power",
        "value": "max 13KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Pulse ignition"
      },
      {
        "label": "Height",
        "value": "1360mm"
      },
      {
        "label": "Safety",
        "value": "Anti-tilt switch and automatic shut-off"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "12/15 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "45 × 45 × 73 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHG-J1",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "8KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "8KW",
      "Piezoelectric ignition",
      "Outdoor use only"
    ],
    "description": "JHG-J1 is a gas patio heater with 8KW output and piezoelectric ignition.",
    "longDescription": "JHG-J1 is a gas patio heater with 8KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-J1 为户外燃气取暖器，输出功率 8KW。",
    "longDescriptionZh": "JHG-J1 为户外燃气取暖器，输出功率 8KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-J1"
      },
      {
        "label": "Power",
        "value": "8KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "980mm"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "12/15 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "42 × 42 × 76 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-J2",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "9KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "9KW",
      "Piezoelectric ignition",
      "Outdoor use only"
    ],
    "description": "JHG-J2 is a gas patio heater with 9KW output and piezoelectric ignition.",
    "longDescription": "JHG-J2 is a gas patio heater with 9KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-J2 为户外燃气取暖器，输出功率 9KW。",
    "longDescriptionZh": "JHG-J2 为户外燃气取暖器，输出功率 9KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-J2"
      },
      {
        "label": "Power",
        "value": "9KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1340mm"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "12/15 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "42.5 × 42.5 × 79 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-I",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "8KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "8KW",
      "Piezoelectric ignition",
      "Outdoor use only"
    ],
    "description": "JHG-I is a gas patio heater with 8KW output and piezoelectric ignition.",
    "longDescription": "JHG-I is a gas patio heater with 8KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-I 为户外燃气取暖器，输出功率 8KW。",
    "longDescriptionZh": "JHG-I 为户外燃气取暖器，输出功率 8KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-I"
      },
      {
        "label": "Power",
        "value": "8KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "27/29 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "97 × 52 × 24 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-N",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "15.6KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "15.6KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "Anti-tilt shut-off"
    ],
    "description": "JHG-N is a gas patio heater with 15.6KW output and piezoelectric ignition.",
    "longDescription": "JHG-N is a gas patio heater with 15.6KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-N 为户外燃气取暖器，输出功率 15.6KW。",
    "longDescriptionZh": "JHG-N 为户外燃气取暖器，输出功率 15.6KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-N"
      },
      {
        "label": "Power",
        "value": "15.6KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1025mm"
      },
      {
        "label": "Safety",
        "value": "Anti-tilt switch and automatic shut-off"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "26/28 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "65 × 49 × 56.6 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JH-D",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "11 kW",
    "control": "",
    "heating": "",
    "features": [
      "Gas patio heater",
      "11 kW",
      "Outdoor use only",
      "Retractable design for storage"
    ],
    "description": "JH-D is a gas patio heater with 11 kW output.",
    "longDescription": "JH-D is a gas patio heater with 11 kW output. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JH-D 为户外燃气取暖器，输出功率 11 kW。",
    "longDescriptionZh": "JH-D 为户外燃气取暖器，输出功率 11 kW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JH-D"
      },
      {
        "label": "Power",
        "value": "11 kW"
      },
      {
        "label": "Energy source",
        "value": "Gas"
      },
      {
        "label": "Design",
        "value": "Retractable"
      },
      {
        "label": "Product dimensions",
        "value": "51.5 × 180 cm"
      },
      {
        "label": "Emitter",
        "value": "Spiral stainless steel, Ø100 mm"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "30/34 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "57 × 56 × 137 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-H6",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "11KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "11KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-H6 is a gas patio heater with 11KW output and piezoelectric ignition.",
    "longDescription": "JHG-H6 is a gas patio heater with 11KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-H6 为户外燃气取暖器，输出功率 11KW。",
    "longDescriptionZh": "JHG-H6 为户外燃气取暖器，输出功率 11KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-H6"
      },
      {
        "label": "Power",
        "value": "11KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1360mm"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "26/28 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "76.5 × 47.5 × 30.5 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-H7",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "9KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "9KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-H7 is a gas patio heater with 9KW output and piezoelectric ignition.",
    "longDescription": "JHG-H7 is a gas patio heater with 9KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-H7 为户外燃气取暖器，输出功率 9KW。",
    "longDescriptionZh": "JHG-H7 为户外燃气取暖器，输出功率 9KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-H7"
      },
      {
        "label": "Power",
        "value": "9KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1395mm"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "32/34 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "78.5 × 45.5 × 35 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-H8",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "11KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "11KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-H8 is a gas patio heater with 11KW output and piezoelectric ignition.",
    "longDescription": "JHG-H8 is a gas patio heater with 11KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-H8 为户外燃气取暖器，输出功率 11KW。",
    "longDescriptionZh": "JHG-H8 为户外燃气取暖器，输出功率 11KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-H8"
      },
      {
        "label": "Power",
        "value": "11KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1395mm"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "32/34 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "78.5 × 45.5 × 35 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-H9",
    "gas": true,
    "form": "standing",
    "type": "Gas patio heater",
    "typeZh": "户外燃气取暖器",
    "power": "11KW",
    "control": "Piezoelectric ignition",
    "heating": "",
    "features": [
      "Gas patio heater",
      "11KW",
      "Piezoelectric ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-H9 is a gas patio heater with 11KW output and piezoelectric ignition.",
    "longDescription": "JHG-H9 is a gas patio heater with 11KW output and piezoelectric ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-H9 为户外燃气取暖器，输出功率 11KW。",
    "longDescriptionZh": "JHG-H9 为户外燃气取暖器，输出功率 11KW。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-H9"
      },
      {
        "label": "Power",
        "value": "11KW"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Piezoelectric ignition"
      },
      {
        "label": "Height",
        "value": "1466mm"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wheels",
        "value": "Included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "32/34 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "95 × 43 × 52 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-F",
    "gas": true,
    "form": "standing",
    "type": "Gas fire table",
    "typeZh": "燃气火炉桌",
    "power": "50,000BTU",
    "control": "Pulse ignition",
    "heating": "",
    "features": [
      "Gas fire table",
      "50,000BTU",
      "Pulse ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-F is a gas fire table with 50,000BTU output and pulse ignition.",
    "longDescription": "JHG-F is a gas fire table with 50,000BTU output and pulse ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-F 为燃气火炉桌，输出功率 50,000BTU。",
    "longDescriptionZh": "JHG-F 为燃气火炉桌，输出功率 50,000BTU。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-F"
      },
      {
        "label": "Power",
        "value": "50,000BTU"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Pulse ignition"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wind guard",
        "value": "Glass wind guard included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "22/25 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "76 × 76 × 22 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHG-G",
    "gas": true,
    "form": "standing",
    "type": "Gas fire table",
    "typeZh": "燃气火炉桌",
    "power": "50,000BTU",
    "control": "Pulse ignition",
    "heating": "",
    "features": [
      "Gas fire table",
      "50,000BTU",
      "Pulse ignition",
      "Outdoor use only",
      "304 stainless steel burner"
    ],
    "description": "JHG-G is a gas fire table with 50,000BTU output and pulse ignition.",
    "longDescription": "JHG-G is a gas fire table with 50,000BTU output and pulse ignition. Designed for open-air patios and outdoor hospitality spaces. Match the fuel supply and regulator to the destination market before installation.",
    "descriptionZh": "JHG-G 为燃气火炉桌，输出功率 50,000BTU。",
    "longDescriptionZh": "JHG-G 为燃气火炉桌，输出功率 50,000BTU。 适用于露台及户外商业休闲空间。安装前请确认目标市场的燃气类型和调压器配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHG-G"
      },
      {
        "label": "Power",
        "value": "50,000BTU"
      },
      {
        "label": "Energy source",
        "value": "LPG"
      },
      {
        "label": "Fuel",
        "value": "propane, butane and mixtures (LPG)"
      },
      {
        "label": "Ignition",
        "value": "Pulse ignition"
      },
      {
        "label": "Burner",
        "value": "304 stainless steel"
      },
      {
        "label": "Lava rock",
        "value": "2.5 kg included"
      },
      {
        "label": "Wind guard",
        "value": "Glass wind guard included"
      },
      {
        "label": "Hose",
        "value": "Included"
      },
      {
        "label": "Regulator",
        "value": "Not included"
      },
      {
        "label": "Use",
        "value": "Outdoor only"
      },
      {
        "label": "Net / gross weight",
        "value": "30/32 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "114 × 70 × 25.5 cm"
      },
      {
        "label": "HS code",
        "value": "7321810000"
      }
    ],
    "sourceImage": "source.png"
  },
  {
    "model": "JHL001",
    "gas": false,
    "form": "standing",
    "type": "Freestanding halogen heater",
    "typeZh": "落地卤素取暖器",
    "power": "3000W (Max)",
    "control": "Remote and Touch button",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Freestanding halogen heater",
      "3000W (Max)",
      "Remote and Touch button",
      "Telescopic pole (1.6m -2.05m)",
      "Tip-over cut-off"
    ],
    "description": "JHL001 is a freestanding halogen heater with 3000W (Max) output and remote and touch button.",
    "longDescription": "JHL001 is a freestanding halogen heater with 3000W (Max) output and remote and touch button. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL001 为落地卤素取暖器，输出功率 3000W (Max)。",
    "longDescriptionZh": "JHL001 为落地卤素取暖器，输出功率 3000W (Max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL001"
      },
      {
        "label": "Power",
        "value": "3000W (Max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Remote and Touch button"
      },
      {
        "label": "Heat settings",
        "value": "3 (1200W-1800W-3000W)"
      },
      {
        "label": "Height",
        "value": "Telescopic pole (1.6m -2.05m)"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off"
      },
      {
        "label": "Material",
        "value": "Stainless Steel, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "58.5 x 58.5 x 205 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "13.6 / 16.3 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "61 × 61 × 43 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHL001-B",
    "gas": false,
    "form": "standing",
    "type": "Freestanding halogen heater",
    "typeZh": "落地卤素取暖器",
    "power": "2100W (Max)",
    "control": "Rocker Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Freestanding halogen heater",
      "2100W (Max)",
      "Rocker Switch",
      "Telescopic pole (1.6m -2.05m)",
      "Tip-over cut-off"
    ],
    "description": "JHL001-B is a freestanding halogen heater with 2100W (Max) output and rocker switch.",
    "longDescription": "JHL001-B is a freestanding halogen heater with 2100W (Max) output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL001-B 为落地卤素取暖器，输出功率 2100W (Max)。",
    "longDescriptionZh": "JHL001-B 为落地卤素取暖器，输出功率 2100W (Max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL001-B"
      },
      {
        "label": "Power",
        "value": "2100W (Max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Heat settings",
        "value": "3 (900W-1200W-2100W)"
      },
      {
        "label": "Height",
        "value": "Telescopic pole (1.6m -2.05m)"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off"
      },
      {
        "label": "Material",
        "value": "Stainless Steel, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "58.5 x 58.5 x 205 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "13.6 / 16.3 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "61 × 61 × 43 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHL004",
    "gas": false,
    "form": "standing",
    "type": "Freestanding halogen heater",
    "typeZh": "落地卤素取暖器",
    "power": "3000W (Max)",
    "control": "Rocker Switch",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Freestanding halogen heater",
      "3000W (Max)",
      "Rocker Switch",
      "Telescopic pole (1.6m -2.08m)",
      "Tip-over cut-off"
    ],
    "description": "JHL004 is a freestanding halogen heater with 3000W (Max) output and rocker switch.",
    "longDescription": "JHL004 is a freestanding halogen heater with 3000W (Max) output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL004 为落地卤素取暖器，输出功率 3000W (Max)。",
    "longDescriptionZh": "JHL004 为落地卤素取暖器，输出功率 3000W (Max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL004"
      },
      {
        "label": "Power",
        "value": "3000W (Max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Heat settings",
        "value": "3 （1200W-1800W-3000W)"
      },
      {
        "label": "Height",
        "value": "Telescopic pole (1.6m -2.08m)"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off"
      },
      {
        "label": "Material",
        "value": "Iron, Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "57x 57 x 208 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "15.2 / 17.3 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "60 × 60 × 46 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHL001-MIZ2",
    "gas": false,
    "form": "standing",
    "type": "Freestanding halogen heater",
    "typeZh": "落地卤素取暖器",
    "power": "1500W",
    "control": "Rocker Switch",
    "heating": "1 Halogen Heating tube",
    "features": [
      "Freestanding halogen heater",
      "1500W",
      "Rocker Switch",
      "Tip-over cut-off"
    ],
    "description": "JHL001-MIZ2 is a freestanding halogen heater with 1500W output and rocker switch.",
    "longDescription": "JHL001-MIZ2 is a freestanding halogen heater with 1500W output and rocker switch. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space.",
    "descriptionZh": "JHL001-MIZ2 为落地卤素取暖器，输出功率 1500W。",
    "longDescriptionZh": "JHL001-MIZ2 为落地卤素取暖器，输出功率 1500W。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。",
    "notes": [],
    "notesZh": [],
    "specs": [
      {
        "label": "Model",
        "value": "JHL001-MIZ2"
      },
      {
        "label": "Power",
        "value": "1500W"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "1 Halogen Heating tube"
      },
      {
        "label": "Control",
        "value": "Rocker Switch"
      },
      {
        "label": "Safety",
        "value": "Tip-over Cut Off， Safety Mesh"
      },
      {
        "label": "Material",
        "value": "Aluminum,iron"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "50 x 50 x 205 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "13.95 / 15.35 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "52 × 52 × 34.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  },
  {
    "model": "JHD001-B",
    "gas": false,
    "form": "ceiling",
    "type": "Hanging halogen heater",
    "typeZh": "吊顶卤素取暖器",
    "power": "3000W (max)",
    "control": "Remote and Touch button",
    "heating": "2 Halogen Heating tubes",
    "features": [
      "Hanging halogen heater",
      "3000W (max)",
      "Remote and Touch button"
    ],
    "description": "JHD001-B is a hanging halogen heater with 3000W (max) output and remote and touch button.",
    "longDescription": "JHD001-B is a hanging halogen heater with 3000W (max) output and remote and touch button. Radiant heat provides focused warmth for people and nearby surfaces. Choose the mounting position and electrical supply to suit your space. Confirm individual heat-setting wattages when ordering.",
    "descriptionZh": "JHD001-B 为吊顶卤素取暖器，输出功率 3000W (max)。",
    "longDescriptionZh": "JHD001-B 为吊顶卤素取暖器，输出功率 3000W (max)。 通过辐射方式为人体和附近物体提供局部温暖，可根据空间布局选择合适的安装位置与电源配置。 各档功率请在订购时确认。",
    "notes": [
      "Confirm individual heat-setting wattages when ordering."
    ],
    "notesZh": [
      "各档功率请在订购时确认。"
    ],
    "specs": [
      {
        "label": "Model",
        "value": "JHD001-B"
      },
      {
        "label": "Power",
        "value": "3000W (max)"
      },
      {
        "label": "Energy source",
        "value": "Electric"
      },
      {
        "label": "Voltage",
        "value": "220–240 V ~ 50 Hz"
      },
      {
        "label": "Heating element",
        "value": "2 Halogen Heating tubes"
      },
      {
        "label": "Control",
        "value": "Remote and Touch button"
      },
      {
        "label": "Material",
        "value": "Aluminum"
      },
      {
        "label": "Plug",
        "value": "EU plug"
      },
      {
        "label": "Cable",
        "value": "1.8-1.9m"
      },
      {
        "label": "Product dimensions",
        "value": "58.5 x 58.5 x 32 cm"
      },
      {
        "label": "Net / gross weight",
        "value": "3.8 / 5.42 kg"
      },
      {
        "label": "Packaging dimensions",
        "value": "61 × 61 × 34.5 cm"
      },
      {
        "label": "HS code",
        "value": "8516292000"
      }
    ],
    "sourceImage": "source.jpeg"
  }
];
